export enum ProspectPages {
  Intro = 'Intro',
  Forms = 'Forms'
}
